import { useCallback, useEffect, useState } from 'react'
import { authService } from '../../service/domain/_service.config'

export type RecoveryStatus = 'loading' | 'ready' | 'expired'

function getRecoveryParamsFromHash(): { access_token: string; refresh_token: string } | null {
  const hash = window.location.hash?.slice(1)
  if (!hash) return null
  const params = new URLSearchParams(hash)
  const access_token = params.get('access_token')
  const refresh_token = params.get('refresh_token')
  if (access_token && refresh_token) return { access_token, refresh_token }
  return null
}

export function useRecoverySession() {
  const [status, setStatus] = useState<RecoveryStatus>('loading')

  const establishSession = useCallback(async () => {
    const session = await authService.getSession()
    if (session) {
      setStatus('ready')
      return
    }
    const tokens = getRecoveryParamsFromHash()
    if (tokens) {
      try {
        await authService.setSession(tokens)
        setStatus('ready')
        window.history.replaceState(null, '', window.location.pathname + window.location.search)
      } catch {
        setStatus('expired')
      }
      return
    }
    setStatus('expired')
  }, [])

  useEffect(() => {
    void establishSession()
  }, [establishSession])

  return status
}
